import { RecordValue, StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { nonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
export const updateIgnoreQueryTrigger = createAction('commerce/triggers/query/updateIgnore', (payload) => validatePayload(payload, {
    q: new StringValue({ emptyAllowed: true, required: true }),
}));
export const applyQueryTriggerModification = createAction('commerce/triggers/query/applyModification', (payload) => validatePayload(payload, new RecordValue({
    values: { originalQuery: nonEmptyString, modification: nonEmptyString },
})));
